 <template>
    <div class="container">
        <div class="content">
            <img class="tip_icon" src="../assets/img/shake_titleimg.png" alt="">
            <div v-if="lotteryDetail.user_have_credit" class="currentCredit">
                <span>{{'当前积分：'+lotteryDetail.user_have_credit}}</span>
                <p v-if="lotteryDetail.credit_desc!=''">{{lotteryDetail.credit_desc}}</p>
            </div>
            <div id="boxArea">
                <div class="shakeTop" :class="{shakeTopAnimationClass: shakeSign}"></div>
                <div class="shakeBottom" :class="{shakeBottomAnimationClass: shakeSign}"></div>
            </div>
            <audio src="../assets/media/wxShakeAudio.mp3" ref="audio"></audio>
            <div class="award_btn">
                <p @click="clickAward">我的中奖记录</p>
            </div>
        </div>
        <section class="tip_text_container" v-if="lotteryDetail.show_desc=='1'"><!-- 奖品说明 -->
                <div class="tip_award">
                    <p>奖项说明</p>
                </div>
                <div class="awardList">
                    <ul class="lists">
                        <li class="list" v-for="(item,index) in prizeListData" :key="index">
                            <p class="awardPic" v-if="prizeListImgDisplay">
                                <img :src="item.image" alt="">
                            </p>
                            <p :class="prizeListImgDisplay?'pName':'pName_sec'">{{item.name}}</p>
                            <p :class="prizeListImgDisplay?'pDesc':'pDesc_sec'">{{item.desc}}</p>
                            <p :class="prizeListImgDisplay?'pSur':'pSur_sec'" v-if="lotteryDetail.show_prize_num=='1'">{{'剩余数量：'+item.prize_number}}</p>
                        </li>
                    </ul>
                </div>
        </section>
        <section class="tip_text_container"><!-- 活动说明 -->
                <div class="tip_award">
                        <p>活动说明</p>
                </div>
                <div class="awardList">
                  <div class="lists" v-if="lotteryDetail.about_lottery">
                      <p class="explain">
                        <pre>{{lotteryDetail.about_lottery}}</pre>
                      </p>
                  </div>
                  <div class="lists" v-else>
                      <p class="explain" v-html="lotteryDetail.desc"></p>
                  </div>
                </div>
        </section>
        <section class="foot">
            <div class="logo">
                <img :src="logo_img" alt="">
            </div>
        </section>
        <!-- 未中奖弹窗 -->
        <div class="lostTip" v-if="lostTipDisplay && !compatibleDisplay">
            <div class="lostTip_content">
                <i class="el-icon-error" @click="loadClose" v-if="lostTipData.type === 0"></i>
                <div class="lostTip_content_text">
                    {{lostTipData.msg}}
                </div>
                <div class="lostTip_btn_area">
                    <div class="btn-item btn-item-normal" v-if="lostTipData.type === 0" @click="loadClose">确 定</div>
                    <div class="btn-item btn-item-normal" v-else @click="gotoCenter">去填写</div>
                    <div class="btn-item btn-item-cancel" v-if="lostTipData.type === 1" @click="loadClose">取 消</div>
                </div>
            </div>
        </div>
        <!-- 不支持运动事件，不能玩提示 -->
        <div class="wrapper-compatible" v-if="compatibleDisplay" @touchmove.prevent>
            <div class="wrap">
                <div class="note">
                    当前环境不支持该活动！
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import Shake from "shake.js";
import formDialogVue from "./formDialog/formDialog.vue";

import {logo_img} from '../config/config';
export default {
  data() {
    return {
      logo_img,
      code: "",
      shakeSign: false,
      shakeSwitch: true,
      formLabelWidth: "30%",
      formSureFlag: true,
      fillInfo: {}, // 中奖表单填写内容
      lostTipDisplay: false,
      lostTipData: {},
      audio: null, // audio标签
      dialogShow: false, // 中奖表单显示开关
      prizeReqData: {}, // 接收请求成功的数据
      compatibleDisplay: false
    };
  },
  props: [
    "lotteryDetail",
    "prizeListData",
    "prizeListImgDisplay",
    "preview",
    "platRight",
    "coordinate"
  ],
  created() {
    this.shakePageInit();
    // shake动作初始化
    this.shakeEventInit();
    // shakejs初始化
    this.shakejsInit();
  },
  mounted() {
    this.audio = document.querySelector("audio");
  },
  beforeDestroy() {
    window.removeEventListener("shake", this.shakeEventDidOccur, false);
  },
  methods: {
    shakeEventInit() {
      const vm = this;

      const EMPTY_VALUE = 100;
      const THREAD_HOLD = 13.8;
      var minX = EMPTY_VALUE,
        minY = EMPTY_VALUE;
      function devicemotion(event) {
        var gravity = event.accelerationIncludingGravity,
          x = gravity.x,
          y = gravity.y;
        if (!x) {
          vm.compatibleDisplay = true;
        }
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (
          Math.abs(x - minX) > THREAD_HOLD &&
          Math.abs(y - minY) > THREAD_HOLD
        ) {
          console.warn("shake happen");
          var event = new CustomEvent("shake");
          window.dispatchEvent(event);
          minX = minY = EMPTY_VALUE;
        }
      };
      /* IOS 13需要请求运动API权限 */
      function devicemotionAuthorization(){
        if (typeof DeviceMotionEvent.requestPermission === 'function') {
          window.addEventListener('click', () => {
            DeviceMotionEvent.requestPermission()
                .then(permissionState => {
                    if (permissionState === 'granted') {
                        window.addEventListener('devicemotion', devicemotion)
                    }
                })
                .catch(console.error);
          })
        } else {
            // ios其他系统可以不通过请求直接摇一摇
            window.addEventListener('devicemotion', devicemotion)
        }
      }
      /* ios13重力感应授权 */
      devicemotionAuthorization();
      window.addEventListener("shake", function() {
        console.log("window shake callback was called");
      });
    },
    platRightCheck() {
      if (this.platRight && this.platRight.right === 0) {
        if (this.platRight.apptype === "WX") {
          this.$router.push("/wxScan");
        } else {
          this.$dialog({
            message: this.platRight.name,
            url: this.platRight.url,
            key: this.platRight.apptype
          });
        }
        return true;
      }
    },
    gotoCenter() {
      this.$router.push("/awardList");
    },
    shakePageInit() {
      // 如果没有点击加载过audio标签，显示会话框
      if (!sessionStorage.getItem("loadAudioMark")) {
        this.lostTip({ type: 0, msg: "摇一摇手机，抽取奖品" });
        sessionStorage.setItem("loadAudioMark", true);
      }
    },
    loadClose() {
      this.lostTipDisplay = false;
      // 不做判断每次都load
      this.audio.load();
    },
    shakejsInit() {
      let myShakeEvent = new Shake({
        threshold: 10,
        timeout: 1000
      });
      myShakeEvent.start();
      window.addEventListener("shake", this.shakeEventDidOccur, false);
    },
    shakeEventDidOccur() {
      // 端检查
      if (this.platRightCheck()) return;
      if (this.shakeSwitch) {
        // 关闭请求入口
        this.shakeSwitch = false;
        setTimeout(() => {
          this.shakeSign = false;
          this.shakeReq();
        }, 1000);
        // 声效和动效
        this.audio.play();
        this.shakeSign = true;
      }
    },
    shakeReq() {
      let vm = this;
      let latitude, longitude;
      if (this.coordinate) {
        latitude = this.coordinate.latitude;
        longitude = this.coordinate.longitude;
      }
      this.Get({
        url: "/activity/api.php",
        data: {
          m: "front",
          subm: "lottery",
          action: "drawprize",
          preview: vm.preview,
          lat: latitude || "",
          lng: longitude || ""
        },
        success: function(data) {
          if (data.code == 3001) {
            vm.prizeReqData = data.data;
            // 处理中奖的情况
            vm.drawResult(vm.prizeReqData);

            // 我直接用请求中的credit和credittype吧
            if (
              vm.prizeReqData.credit_type != 0 &&
              vm.prizeReqData.credit != 0 &&
              typeof vm.lotteryDetail.user_have_credit !== "undefined"
            ) {
              if (vm.prizeReqData.credit_type == 1) {
                vm.lotteryDetail.user_have_credit -= vm.lotteryDetail.credit;
              } else if (data.data.credit_type == 2) {
                vm.lotteryDetail.user_have_credit += vm.lotteryDetail.credit;
              }
            }
            // 更新prizelist奖品数量信息等
            if (data.data.prize_id != 0) {
              vm.prizeListUpdate();
            }
          }
        },
        error: function(data) {
          if (
            data.code == 5007 ||
            data.code == 5110 ||
            data.code == 5011 ||
            data.code == 5013 ||
            data.code == 5014 ||
            data.code == 5020 ||
            data.code == 5107
          ) {
            // vm.$router.replace("/");
            // window.location.reload(true);
          }
          // vm.lostTip(data.msg)
          vm.lostTip({ type: 0, msg: data.msg });
        }
      });
    },
    prizeListUpdate() {
      this.$emit("prizeListUpdateNotice");
    },
    drawResult(data) {
      // prize_id不为0时中奖
      if (data.prize_id) {
        if (data.prize_type == 1 && data.receive_msg.length) {
          this.fields = {
            m: "front",
            subm: "lottery",
            action: "receivemsg",
            id: data.prize_receive_record_id
          };
          for (let i = 0; i < data.receive_msg.length; i++) {
            let item = data.receive_msg[i];
            this.fillInfo[item] = "";
          }
          // 实物且开启了注册，显示领奖信息页面
          // type为1表示中奖，且是实物表单中奖
          this.lostTip({ type: 1, msg: data.msg + "，别忘记填写中奖信息！" });
        } else if(data.prize_type === 3){
          this.alertPrize(data.msg, '立即领取', data.prize_url )
        } else {
          // type为0，表示仅显示文案
          this.lostTip({ type: 0, msg: data.msg });
        }
      } else {
        this.lostTip({ type: 0, msg: data.msg });
      }
    },
    lostTip(obj) {
      this.lostTipData = obj;
      this.lostTipDisplay = true;
    },
    alertPrize(){//中奖后的弹框
      this.$emit.apply(this,[].concat.apply(['alertPrize'], arguments));
    },
    clickAward() {
      // 端检查
      if (this.platRightCheck()) return;
      this.$emit("clickAward");
    },
    getRandom(min, max) {
      let range = max - min;
      return min + Math.round(Math.random() * range);
    }
  },
  watch: {
    lostTipDisplay: function(val, oldVal) {
      if (!val) {
        this.shakeSwitch = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .wrapper-compatible {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 199;
    .wrap {
      margin: 50% auto 0;
      width: 72%;
      // min-height: 120px;
      border-radius: 6px;
      background-color: #fff;
      text-align: center;
      overflow: hidden;
      .note {
        box-sizing: border-box;
        padding: 20px 10px;
        min-height: 5em;
      }
    }
  }
}
.lostTip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 198;
  .lostTip_content {
    position: relative;
    width: 80%;
    // min-height: 10%;
    padding: 10% 0 5%;
    border-radius: 6px;
    background-color: #fff;
    margin: 50% auto 0;
    .lostTip_content_text {
      width: 90%;
      min-height: 40px;
      // background-color: #ccc;
      margin: auto;
      margin-bottom: 30px;
    }
    .lostTip_btn_area {
      display: flex;
      justify-content: center;
      .btn-item {
        width: 30%;
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        border: 1px solid orange;
      }
      .btn-item-normal {
        background-color: orange;
        color: #fff;
      }
      .btn-item-cancel {
        margin-left: 2em;
        border-color: #000;
      }
    }
    & > i {
      color: #e21843;
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(50%) translateY(-50%);
      background-color: #fff;
      border-radius: 50%;
    }
  }
}
.content {
  background-image: url("../assets/images/title_bg.png");
  background-size: 100% 100%;
}
#boxArea {
  width: 70vw;
  height: 70vw;
  /* border: 1px solid red; */
  margin: 30px auto;
  background: url("../assets/img/shake_backimg.png") no-repeat center;
  background-size: 50%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: ; */
}
.shakeTop {
  flex: 1;
  background: url("../assets/img/shake_top.png") no-repeat center bottom;
  background-size: contain;
  /* transform: translateY(-16vw); */
}
.shakeBottom {
  flex: 1;
  background: url("../assets/img/shake_bottom.png") no-repeat center top;
  background-size: contain;
  /* transform: translateY(16vw); */
}
.shakeTopAnimationClass {
  animation: shakeTopAnimation 1s ease;
}
.shakeBottomAnimationClass {
  animation: shakeBottomAnimation 1s ease;
}
@keyframes shakeTopAnimation {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-16vw);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes shakeBottomAnimation {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(16vw);
  }
  100% {
    transform: translateY(0);
  }
}
.tip_icon {
  width: 60%;
  margin: 15px auto;
}
.currentCredit {
  margin-bottom: 10px;
  color: #444e45;
}
#squareBox {
  width: 96vw;
  height: 96vw;
  margin: 0 auto;
  background: orange;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: url(/static/image/lamp_active.gif); */
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/shake.vue